
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","data-name":"Layer 1","viewBox":"0 0 100 86.602"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group"}},[_c('path',{attrs:{"data-name":"Compound Path","d":"M91.198 50.647C89.272 34.81 77.18 21.862 61.236 17.69a12.413 12.413 0 1 0-22.472 0C22.82 21.862 10.728 34.81 8.802 50.647a10.594 10.594 0 0 0-1.391 20.546L8.802 75.9a15.088 15.088 0 0 0 14.34 10.7h53.717a15.088 15.088 0 0 0 14.339-10.7l1.391-4.708a10.594 10.594 0 0 0-1.391-20.546zM10.514 63.06a2.033 2.033 0 0 1 0-4.066h78.972a2.033 2.033 0 0 1 0 4.066zM46.148 12.34A3.852 3.852 0 1 1 50 16.19a3.852 3.852 0 0 1-3.852-3.852zM50 24.75c16.48 0 30.07 11.13 32.53 25.682H17.47C19.93 35.987 33.52 24.751 50 24.751zm26.859 53.29H23.14a6.42 6.42 0 0 1-6.206-4.601l-.535-1.82h67.2l-.535 1.82a6.42 6.42 0 0 1-6.206 4.601z"}})])])
          )
        }
      }
    